


















import { GPageBase } from '@/mixins';
import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import { ScoreUtils } from '@/utils/score.utils';

@Component({
  name: 'GStudentRecordScoreComparison',
  computed: {},
  methods: {},
})
export default class GStudentRecordScoreComparison extends mixins(GPageBase) {
  @Prop() selfScore: number;
  @Prop() overallScore: number;
  @Prop() selfScoreGiftedCount: number;
  @Prop() selfScoreIsNewScore: boolean;

  getScoreProgressStatusString(count: number, isNew: boolean): string {
    return ScoreUtils.toStringScoreProgressStatus(count, isNew);
  }
}
